import './style.scss';
import template from './betaTag.html';

export default {
  template,
};
